import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { FiMenu, FiUsers, FiBriefcase, FiDollarSign, FiFileText, FiUserCheck, FiCodesandbox, FiPackage, FiMapPin } from "react-icons/fi";
import "./Sidebar.css";
import logo from "../../img/social-black.png";
import { getNavItemsForUser } from "./navConfig";

const Sidebar = ({ isExpanded, setIsExpanded, currentUser, todoTaskCount = 0 }) => {
  const navItems = getNavItemsForUser(currentUser);
  const [hoveredItem, setHoveredItem] = useState(null);
  const [menuPosition, setMenuPosition] = useState({ top: 0 });
  const location = useLocation();

  // Define submenu items for pages that have them
  const submenuConfig = {
    "/outreach": [
      { name: "People", path: "/outreach/people", icon: <FiUsers /> },
      { name: "Companies", path: "/outreach/companies", icon: <FiBriefcase /> },
      { name: "Sales", path: "/outreach/sales", icon: <FiDollarSign /> },
      { name: "States", path: "/outreach/states", icon: <FiMapPin /> },
      { name: "Email Templates", path: "/outreach/email-templates", icon: <FiFileText /> }
    ],
    "/partners": [
      { name: "Partners", path: "/partners/manager", icon: <FiUserCheck /> },
      { name: "QR Generator", path: "/partners/qr-generator", icon: <FiCodesandbox /> },
      { name: "ONEbox Manager", path: "/partners/onebox-manager", icon: <FiPackage /> }
    ]
  };

  const handleMouseEnter = (item, event) => {
    if (submenuConfig[item.path]) {
      const rect = event.currentTarget.getBoundingClientRect();
      setMenuPosition({ top: rect.top });
      setHoveredItem(item.path);
    }
  };

  return (
    <div className={`sidebar ${isExpanded ? "expanded" : "collapsed"}`}>
      <div className="sidebar-logo-container">
        <img 
          src={logo} 
          alt="Logo" 
          className="logo-small" 
        />
      </div>
      
      <button className="menu-toggle" onClick={() => setIsExpanded(!isExpanded)}>
        <FiMenu />
      </button>

      {navItems.map((item) => {
        const hasSubmenu = submenuConfig[item.path];
        const submenuItems = submenuConfig[item.path];
        const isCurrentSection = location.pathname.startsWith(item.path);

        return (
          <div 
            key={item.name}
            className="sidebar-item-wrapper"
            onMouseEnter={(e) => handleMouseEnter(item, e)}
            onMouseLeave={() => hasSubmenu && setHoveredItem(null)}
          >
            <NavLink 
              to={hasSubmenu ? submenuItems[0].path : item.path}
              className={({ isActive }) => `sidebar-item ${isActive || isCurrentSection ? 'active' : ''}`}
            >
              <div className="sidebar-icon-wrapper">
                {item.icon}
                {item.path === "/todo" && todoTaskCount > 0 && (
                  <span className="sidebar-badge">{todoTaskCount > 99 ? '99+' : todoTaskCount}</span>
                )}
              </div>
              {isExpanded && <span className="sidebar-text">{item.name}</span>}
            </NavLink>
          </div>
        );
      })}

      {/* Render flyout menu outside of sidebar items */}
      {hoveredItem && submenuConfig[hoveredItem] && (
        <div 
          className="sidebar-flyout-menu"
          style={{ top: `${menuPosition.top}px` }}
          onMouseEnter={() => setHoveredItem(hoveredItem)}
          onMouseLeave={() => setHoveredItem(null)}
        >
          {submenuConfig[hoveredItem].map((subItem) => (
            <NavLink
              key={subItem.name}
              to={subItem.path}
              className={({ isActive }) => `sidebar-flyout-item ${isActive ? 'active' : ''}`}
            >
              {subItem.icon}
              <span>{subItem.name}</span>
            </NavLink>
          ))}
        </div>
      )}
    </div>
  );
};

export default Sidebar;
